import { Injectable } from '@angular/core';

import { ROUTING_PATH } from '@shared/constants/routingPath';

import {
  TrialInsightsTableModel,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
} from '../../models/trial-insights-table.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsFinancePatientsEnrolledTableService implements TrialInsightsTableModel {
  route = ROUTING_PATH.BUDGET.INDEX;
  subRoute = `${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST}`;

  createTable = (
    rowData: TrialInsightsTableRowData[] = [],
    investigatorForecastEnabled?: boolean
  ): TrialInsightsTableOptions => {
    const colors = ['#138EE7'];

    const data = rowData.map((row, index) => {
      row.color = colors[index];

      return row;
    });

    let route = this.route;
    let subRoute = this.subRoute;

    if (!investigatorForecastEnabled) {
      route = ROUTING_PATH.INVESTIGATOR.INDEX;
      subRoute = ROUTING_PATH.INVESTIGATOR.PATIENT_TRACKER;
    }

    return {
      buttons: {
        data: [{ key: 'patientEnrolled', value: 'patientEnrolled' }],
        defaultButtonKey: 'patientEnrolled',
        display: false,
      },
      header: {
        data: [
          {
            buttonKey: 'patientEnrolled',
            leftValue: 'patientEnrolled',
            rightValue: 'patientEnrolled',
          },
        ],
        display: false,
      },
      link: {
        display: true,
        url: `/${route}/${subRoute}`,
        value: investigatorForecastEnabled ? 'View Investigator Forecast' : 'View Patient Tracker',
      },
      rowData: {
        compact: true,
        data: data,
      },
    };
  };
}
